import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Subject } from 'rxjs';
import { environment } from 'environments/environment';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { takeUntil } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SignalRService {

    private hubConnection?: signalR.HubConnection;
    private inwardUpdate$ = new Subject<void>();
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    private _starting = false;

    user: User;

    inwardUpdates$ = this.inwardUpdate$.asObservable();

    constructor(private _userService: UserService) {
        _userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;
            });
    }

    startConnection(): void {
        // Idempotent: don't recreate if already connected/connecting.
        if (this.hubConnection || this._starting) {
            return;
        }

        this._starting = true;

        this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(
                environment.baseUrl.substring(0, environment.baseUrl.lastIndexOf('/api')) + '/notify'
            )
            .withAutomaticReconnect()
            .build();

        this.hubConnection.on('SendOffersToUser', (response: any) => {
            if (!response) { return; }

            // 3 = InwardAddOrUpdate (new inward / inward edit, including initial assignment)
            // 4 = ReadyForOutward
            // 6 = JobStatusChange (status workflow change via status-change dialog)
            const t = response.notificationType;
            if (t === 3 || t === 4 || t === 6) {
                // Always notify subscribers — the pending-inward endpoint is already
                // server-filtered to the current user, so a stray refetch is harmless.
                // Filtering on response.data === user.id here proved unreliable:
                // - user object might not be loaded yet when the message arrives
                // - type/coercion mismatches (long vs number) silently drop events
                this.inwardUpdate$.next();
            }
        });

        this.hubConnection.start()
            .then(() => { this._starting = false; })
            .catch(err => {
                this._starting = false;
                console.error('SignalR error:', err);
            });
    }
}
